import { Box, Flex } from "@chakra-ui/react";
import { ProgressCircular } from "components/RFQ/ProgressIndicator";
// import { AvatarGroup } from "components/AvatarGroup";
import StatusBadge from "components/RFQ/StatusBadge/StatusBadge";
import { TabHeader } from "components/TabHeader";
import React, { useState } from "react";
import moment from "moment-timezone";
import SkeletonBase from "newui/components/Skeleton";
import { SubmissionDeadline } from "components/RFQ/SubmissionDeadline/SubmissionDeadline";
import { IsNullOrEmptyHtml } from "helpers/stringHelper";
import SingleAccordion from "newui/components/SingleAccordion";

const HeaderCard = ({ rfqDetail, isLoading }) => {
	const [isDescriptionShown, setIsDescriptionShown] = useState(false);
	const { accepted, all, submitted } = rfqDetail?.supplierInvited || {
		accepted: [],
		all: [],
		declined: [],
		submitted: [],
	};
	const allTotal = all?.length || 0;
	const submittedTotal = submitted?.length || 0;
	const acceptedTotal = accepted?.length || 0;
	const projectName = rfqDetail?.project?.name || null;

	const hasDescription = !IsNullOrEmptyHtml(rfqDetail?.description);
	const hasScope = !IsNullOrEmptyHtml(rfqDetail?.escopeOfService);
	const displayDescriptionScope = hasDescription || hasScope;
	const hasDescriptionAndScope = hasDescription && hasScope;

	return (
		<Box className="min-h-80 w-full rounded-md border py-10 shadow-xl">
			{/* ALWAYS VISIBLE HEADER */}
			<Flex
				id="header-wrapper"
				className="justify-between"
				gap={10}
			>
				{/* LEFT SIDE — TabHeader + Accordion underneath */}
				<div
					id="header-left"
					className="w-full px-6"
				>
					{projectName && (
						<p className="-mb-6 text-base text-secondary-500">{projectName}</p>
					)}

					<TabHeader
						noDivider={true}
						heading={rfqDetail?.name || " - "}
						isLoading={isLoading}
						color="#003CE9"
					/>
					{displayDescriptionScope && (
						<SingleAccordion
							defaultButtonText={`Click to ${isDescriptionShown ? "hide" : "view"} 
											${hasDescription && "description"}
											${hasDescription && hasScope ? " and " : ""}
											${hasScope && "scope"}`}
							onAccordionChange={setIsDescriptionShown}
						>
							<div>
								{hasDescription && (
									<div>
										{hasDescriptionAndScope && (
											<p className="text-sm font-bold text-secondary-500">
												Project Description
											</p>
										)}
										<p
											dangerouslySetInnerHTML={{
												__html: rfqDetail?.description,
											}}
										></p>
									</div>
								)}
								{hasScope && (
									<div className={hasDescription && "mt-4"}>
										{hasDescriptionAndScope && (
											<p className="text-sm font-bold text-secondary-500">
												Scope of Service
											</p>
										)}
										<p
											dangerouslySetInnerHTML={{
												__html: rfqDetail?.escopeOfService,
											}}
										></p>
									</div>
								)}
							</div>
						</SingleAccordion>
					)}
					{!isLoading ? (
						<Flex
							className={`flex-col gap-4 text-base font-normal ${displayDescriptionScope ? "mt-4" : "mt-8"}`}
						>
							{/* CLIENT */}
							<Flex gap={4}>
								<p className="min-w-48 text-secondary-500">Client</p>
								<p className="font-semibold">{rfqDetail?.client || " - "}</p>
							</Flex>

							{/* PROJECT LOCATION */}
							<Flex gap={4}>
								<p className="min-w-48 text-secondary-500">Project Location</p>
								<p className="font-semibold">{rfqDetail?.location || " - "}</p>
							</Flex>

							{/* RFx PUBLISHED */}
							<Flex gap={4}>
								<p className="min-w-48 text-secondary-500">
									RFx Published Date
								</p>
								<p className="font-semibold">
									{rfqDetail?.rfxPublished
										? moment(rfqDetail?.rfxPublished).format("dddd DD MMM YYYY")
										: " - "}
								</p>
							</Flex>
						</Flex>
					) : (
						<SkeletonBase />
					)}
				</div>

				{/* RIGHT SIDE — Left-aligned now */}
				{!isLoading && (
					<Flex
						direction="column"
						className="w-[40%] px-6"
						gap={4}
						align="flex-start" // <-- LEFT ALIGN EVERYTHING
					>
						{/* RFx Status */}
						<Flex
							align="center"
							gap={3}
						>
							<p className="text-sm text-secondary-500">RFx Status</p>
							<StatusBadge status={rfqDetail?.status} />
						</Flex>

						{/* Submission Deadline */}
						<div>
							<p className="text-sm text-secondary-500">Submission Deadline</p>
							<p className="font-semibold">
								{
									<SubmissionDeadline
										dateFormat={"long"}
										deadlineDateTime={rfqDetail?.submissionDeadline}
										deadlineTimeZone={rfqDetail?.submissionTimezone}
										submissionStatus=""
									/>
								}
							</p>
						</div>

						{/* Progress Circles */}
						<Flex
							gap={4}
							mt={4}
						>
							<ProgressCircular
								detail={
									<div className="text-base">
										<p className="text-xs font-medium">Accepted</p>
										<h1 className="text-2xl font-semibold text-primary-900">
											{allTotal > 0 ? `${acceptedTotal} / ${allTotal}` : "-"}
										</h1>
									</div>
								}
								progress={(acceptedTotal / allTotal) * 100 || 0}
								size="sm"
							/>

							<ProgressCircular
								detail={
									<div className="text-base">
										<p className="text-xs font-medium">Submitted</p>
										<h1 className="text-2xl font-semibold text-primary-900">
											{acceptedTotal > 0
												? `${submittedTotal} / ${acceptedTotal}`
												: "-"}
										</h1>
									</div>
								}
								progress={(submittedTotal / acceptedTotal) * 100 || 0}
								size="sm"
							/>
						</Flex>
					</Flex>
				)}
			</Flex>
		</Box>
	);
};

export default HeaderCard;
